<template>
    <div class="qcdetail">
   <big-img v-if="showImg" @clickit="viewImg" :imgSrc="imgSrc"></big-img>
        <div style="width: 100%">
            <van-nav-bar
                class="restclass"
                title="派工单"
                left-text="返回"
                left-arrow
                @click-left="getBack" />
        </div>
          
        <div class="content">
            <van-tabs v-model="activeName" swipeable>
                <van-tab title="维修信息" name="info">
                    <van-form>
                        <van-cell-group title="报修信息">
                            <van-field v-model="formData.maintenanceType" label="维修类型" required readonly />
                            <van-field v-model="formData.faultDescription" label="故障描述" readonly />
                            <el-row>
                                <div class="imgAdd" style="padding:0 0.213333rem">
                                    <span class="itemImg" v-for="(item,index) in fileList " :key="index">
                                        <img :src="item.url" alt="图片" class="uploadimg" @click.stop="clickImg($event)">
                                    </span>
                                </div>
                            </el-row>
                        </van-cell-group>
                        <van-cell-group title="" style='position:relative;width:100vw;'>
                            <div style='position:absolute; right:5vw;top:2vh;' @click="routetos">整车照片</div>
                        </van-cell-group>
                        <van-cell-group title="维修项目">
                            <van-list>
                                <div v-for="(item, index) in formData.items" :key="item.Id" style="margin: 5px;">
                                    <MaintainItem :item="item" :form-data="formData" :index="index" @onItemClick="onItemClick($event, index, formDataCopy, formDataCopy.items[index])" />
                                    <van-cell v-if="formData.items.length>0" title="配件明细" />
                                    <el-table v-if="formData.items.length>0" :data="item.parts" border :summary-method="getSummaries"
                                        show-summary style="width: 100%" :header-cell-class-name="'tq-table-rom-header'" size="mini">
                                        <el-table-column
                                            type="index"
                                            label="序号"
                                            width="40"
                                            align="center" />
                                        <el-table-column
                                            v-if="formData.enumWorkOrderType == 2"
                                            label="是否返修"
                                            width="60"
                                            align="center">
                                            <template slot-scope="scope">
                                                <van-switch v-model="scope.row.isRework"
                                                    :active-value="1"
                                                    :inactive-value="0"
                                                    size="24px" />
                                            </template>
                                        </el-table-column>
                                        <el-table-column prop="billStatusName" label="状态" width="50" align="center">
                                            <template slot-scope="scope">
                                                {{ scope.row.billStatusName?scope.row.billStatusName:'正常' }}
                                            </template>
                                        </el-table-column>
                                        <el-table-column prop="customerBillNo" label="出库单号">
                                            <template slot-scope="scope">
                                                {{ scope.row.billStatusName=='缺件'?'-':scope.row.customerBillNo }}
                                            </template>
                                        </el-table-column>
                                        <el-table-column prop="part" label="配件名称" />
                                        <el-table-column prop="num" label="数量" width="50" />
                                        <el-table-column prop="unitPrice" label="单价">
                                            <template slot-scope="scope">
                                                {{ scope.row.billStatusName=='缺件'?'-':scope.row.unitPrice }}
                                            </template>
                                        </el-table-column>
                                        <el-table-column prop="totalPrice" label="合计金额">
                                            <template slot-scope="scope">
                                                {{ scope.row.billStatusName=='缺件'?'-':scope.row.totalPrice }}
                                            </template>
                                        </el-table-column>
                                    </el-table>
                                </div>
                            </van-list>
                            <van-popup v-model="showItemDetail" position="bottom">
                                <MaintainItemDetail ref="mitemDetail" :detail-data="itemDetailData" :item-detail-wrok-type="itemDetailWrokType" :parent-type="parentType"
                                    :form-item="formItem" :form="form" @onSaveDetailClick="onSaveDetailClick" @onFaultReasonChange="onFaultReasonChange" />
                            </van-popup>
                        </van-cell-group>
                        <van-cell-group>
                            <van-col v-if="$_has('maintain:qualitycheck:edit')" span="16" offset="4">
                                <van-button v-if="showSubmitButton" round block type="info"
                                    style="margin:30px 0;"
                                    size="large"
                                    class="nextSpan" @click="onSubmit">提交</van-button>
                            </van-col>
                        </van-cell-group>
                    </van-form>
                </van-tab>
                <van-tab title="基本信息" name="base">
                    <MaintainInfo :base-info="formData" :parent-type="parentType" :form-data="formData" />
                </van-tab>
            </van-tabs>
        </div>
        <Repairpopup
            v-if="equiTimingRunVisible"
            :visible.sync="equiTimingRunVisible"
            :modal-obj="modalObj"
            :repair-type="parentType"
            :repair-item="formItem"
            @onRepairPopupClose="onRepairPopupClose" />
        <bottom />
    </div>
</template>

<script>
import bottom from '@/components/bottom'
import MaintainItem from '@/components/MaintainItem'
import MaintainInfo from '@/components/MaintainInfo'
import MaintainItemDetail from '@/components/MaintainItemDetail'
import { getQualityCheckItem, qualityCheckSubmit, WorkOrderhistoryList } from '@/api/maintain'
import { Toast } from 'vant'
import Repairpopup from '@/views/maintain/components/repairpopup.vue'
import BigImg from '../maintain/components/bigImg.vue'

export default {
    name: 'QualityCheckDetail',
    components: {
        bottom,
        MaintainItem,
        MaintainInfo,
        MaintainItemDetail,
        Repairpopup,
        BigImg
    },
    data() {
        return {
            showImg:false,
      imgSrc: '',
            showSubmitButton: true,
            modalObj: {
                title: '维修历史',
                tableData: [],
                item: null
            },
            fileList: [],
            nowork: true,
            equiTimingRunVisible: false,
            activeName: 'info',
            itemDetailData: null,
            itemDetailWrokType: 0,
            partsData: null,
            showItemDetail: false,
            showPartsDetail: false,
            maintainItemIndex: -1,
            showRework: false,
            formData: {},
            parentType: 'quality',
            formDataCopy: {},
            formItem: {},
            form: {
            }
        }
    },
    created() {
        getQualityCheckItem(this.$route.query.id)
        .then((res) => {
            this.formData.vehiclePicture = this.$route.query.photos
            if (res.data.entranceUrl) {
                res.data.fileList = []
                // const picture = res.data.entranceUrl.split(';')
                var picture = res.data.entranceUrl.split(';').filter(function(s) {
                    return s && s.trim() // 注：IE9(不包含IE9)以下的版本没有trim()方法
                })
                console.log(picture)
                picture.forEach(item => {
                    res.data.fileList.push({
                        url: item
                    })
                    this.fileList.push({
                        url: item
                    })
                })
            }
            if (res.code == 200) {
                res.data.maintenanceType = res.data.enumMaintenanceType == 2 ? '场内维修' : '现场维修'
                res.data.entryTime ? res.data.entryTime = res.data.entryTime.replace('T', ' ') : res.data.entryTime = ''
                this.formData = res.data
                this.formDataCopy = JSON.parse(JSON.stringify(res.data))
                if(res.data.vehiclePicture){
                    if(this.$route.query.photos){
                        this.formData.vehiclePicture=this.$route.query.photos
                        
                    }else{
                        this.formData.vehiclePicture=res.data.vehiclePicture
                    }
                }
            }
        })
    },
  
    methods: {
         clickImg(e) {
      this.showImg = true;
      // 获取当前图片地址
      this.imgSrc = e.currentTarget.src;

      },
      viewImg(){
        console.log(1111)
      this.showImg = false;
    },
        routetos() {
            this.$router.push({ path: '/partsrepairszhijian', query: {id: this.$route.query.id,photos:this.formData.vehiclePicture} })
        },
        // 点击删除
        delImg(index) {
        this.submititem.entranceUrl = ''
            if (isNaN(index) || index >= this.fileList.length) {
            return false;
            }
            this.fileList.splice(index, 1);
            if(this.fileList.length>0){
                this.fileList.forEach(item=>{
                this.submititem.entranceUrl = this.submititem.entranceUrl.concat(item.url + ';')
                })
            }
            console.log(this.submititem.entranceUrl)
        },
        // 点击的时候调用相机
        clicktotakephotos(val) {
            const obj = {
                url:process.env.VUE_APP_IMG+val
            }
            this.fileList.push(obj)
            this.submititem.entranceUrl = this.submititem.entranceUrl.concat(process.env.VUE_APP_IMG + val+';')
            
        },
        clicktotakephotose() {
            window.test.openCamera('我是水印')
        },
        getBack() {
            this.$router.push({ path: '/qualityCheckList' })
        },
        onItemClick: function(item, index, form, val) {
            this.showItemDetail = true
            this.maintainItemIndex = index
            this.itemDetailData = item
            this.form = form
            this.formItem = val
            this.itemDetailWrokType = this.formData.enumWorkOrderType
            this.$nextTick(() => {
                this.$refs.mitemDetail.initReturnData()
            })
        },
        getSummaries(param) {
            const { columns, data } = param
            const sums = []
            let values = []
            columns.forEach((column, index) => {
                if (index === 0) {
                    sums[index] = '合计'
                    return
                }
                if (column.property === 'totalPrice') {
                    values = data.map(item => Number(item['totalPrice']))
                }
                if (column.property === 'totalPrice') {
                    sums[index] = values.reduce((prev, curr) => {
                        const value = Number(curr)
                        if (!isNaN(value)) {
                            return Number(prev.toFixed(2)) + Number(curr.toFixed(2))
                        } else {
                            return Number(prev.toFixed(2))
                        }
                    }, 0)
                    if (sums[7]) {
                        sums[7] = Number(sums[index]).toFixed(2)
                    } else {
                        sums[6] = Number(sums[index]).toFixed(2)
                    }
                    sums[index]
                } else {
                    sums[index]
                }
            })
            return sums
        },
        onSaveDetailClick(data) {
            console.log(1111111, data)
            this.showItemDetail = false
            if (this.maintainItemIndex > -1) {
                this.formData.items[this.maintainItemIndex].enumQualityInspectionResult = data.qualityInspectionResultVal
                this.formData.items[this.maintainItemIndex].qualityNotReason = data.qualityNotReason
                this.formData.items[this.maintainItemIndex].enumFaultReason = data.faultReasonVal
                this.formData.items[this.maintainItemIndex].workOrderMen = data.workerList
                this.formData.items[this.maintainItemIndex].workHour = data.workHour
                this.formData.items[this.maintainItemIndex].part = data.part
                this.formData.items[this.maintainItemIndex].partId = data.partId
                this.formData.items[this.maintainItemIndex].position = data.position
                this.formData.items[this.maintainItemIndex].unitPrice = data.unitPrice
                this.formData.items[this.maintainItemIndex].maintainItemNum = data.maintainItemNum
                this.formData.items[this.maintainItemIndex].totalPrice = data.totalPrice
                this.formData.items[this.maintainItemIndex].maintainItem = data.maintainItem ? data.maintainItem : null
                this.formData.items[this.maintainItemIndex].maintainItemId = data.maintainItemId ? data.maintainItemId : null
            }
            this.$refs.mitemDetail.clearData()
        },
        onFaultReasonChange: function(data) {
            console.log(11111111, data)
            this.faultData = data
            if (data.text === '配件质量' || data.text === '维修装配') {
                this.equiTimingRunVisible = true
                this.showItemDetail = false
                this.formItem = this.faultData
                WorkOrderhistoryList({ vehicleId: this.formData.vehicleId, maintainItemId: data.maintainItemId, partId: null }).then(res => {
                    this.modalObj.tableData = res.data
                })
            }
        },
        onRepairPopupClose: function() {
            this.formData.items[this.maintainItemIndex].enumFaultReason = 1 // 自然损坏
        },
        onSubmit() {
            console.log(this.formData)

            this.nowork = true
            let count = 0
            this.gzyy = true
            this.zjjg = true
            let workHour = true
            let unitPrice = true
            let part = true
            let position = true

            // var hasPass = true
            this.formData.items.forEach((item) => {
                // if (item.enumQualityInspectionResult === 0 || item.enumQualityInspectionResult === 1 || item.enumQualityInspectionResult === 3) {
                //     hasPass = false
                // }
                if (!item.maintainItem) {
                    count++
                }
                if (!item.part) {
                    part = false
                }
                if (!item.position) {
                    position = false
                }
                if (item.workHour === '') {
                    workHour = false
                }
                if (item.unitPrice === '') {
                    unitPrice = false
                }
                if (item.workOrderMen.length == 0) {
                    this.nowork = false
                } else {
                    item.workOrderMen.forEach(items => {
                        if (!items.workerName || !items.percent) {
                            this.nowork = false
                        }
                    })
                }
                item.statementMen = item.workOrderMen
                if (!item.enumFaultReason) {
                    this.gzyy = false
                }
                if (item.enumQualityInspectionResult == 0) {
                    this.zjjg = false
                }
            })
            // if (hasPass) {
            //     this.showSubmitButton = false
            // }
            console.log(this.formData)
            if (!this.gzyy) {
                Toast.fail('故障原因必填')
                return
            }
            if (!this.zjjg) {
                Toast.fail('质检结果必填')
                return
            }
            if (count != 0) {
                Toast.fail('维修项目必填')
                return
            }
            console.log('是否成功', workHour, unitPrice)
            if (!workHour) {
                Toast.fail('工时必填')
                return
            }
            if (!unitPrice) {
                Toast.fail('工时单价必填')
                return
            }
            // if (!this.nowork) {
            //     Toast.fail('维修工，权责不能为空')
            //     return
            // }
            qualityCheckSubmit(this.formData)
                .then(res => {
                    if (res.isSuccess) {
                        // 提交成功
                        Toast.success('提交成功')
                        this.showSubmitButton = false
                        this.$router.push({ path: '/qualityCheckList' })
                    } else {
                        Toast.success(res.message)
                    }
                })
        }
    }
}
</script>

<style lang='scss' scoped>
.qcdetail{
    width: 100%;
    margin-bottom: 200px;
}
.nav{
  width: 100%;
  padding: 20px 0px;
  background: #3498ff;
  color: #fff;
  .nav-title{
    width: 100%;
    font-size: 30px;
    text-align: center;
    display: block;
  }
}
.content{
    
    padding: 16px;
    padding-top: 10px;
    
}
</style>
